export const GET_FAQS = "GET_FAQS";
export const GET_FAQ_DETAIL = "GET_FAQ_DETAIL";
export const UPDATE_FAQ = "UPDATE_FAQ";
export const DELETE_FAQS = 'DELETE_FAQS';
export const API_RESPONSE_SUCCESS = "API_RESPONSE_SUCCESS";
export const API_RESPONSE_ERROR = "API_RESPONSE_ERROR";
export const GET_SUB_FAQS = 'GET_SUB_FAQS'; 